import { ButtonProps, Select } from "@ttc3k/trekker";
import { Input } from "@ttc3k/trekker";
import { Text } from "@ttc3k/trekker";
import {
  EnumWidgetEventSettingsDisplayType,
  EnumWidgetType,
} from "gql/generated";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { SimpleErrorNotification } from "shared/components/atoms/SimpleErrorNotification";
import { SimpleLoader } from "shared/components/atoms/SimpleLoader";
import { Flex } from "styled-system/jsx";
import { useStartNewOperatorWidget } from "./useStartNewOperatorWidget";

type StartNewOperatorWidgetProps = {
  setOnCloseClick: Dispatch<SetStateAction<() => void>>;
  setCancelButtonProps: Dispatch<SetStateAction<ButtonProps>>;
  setNextButtonProps: Dispatch<SetStateAction<ButtonProps>>;
  onClose: () => void;
  onNextClick: (
    widgetType: EnumWidgetType,
    name: string,
    listId?: string,
    eventSettings?: {
      displayType: EnumWidgetEventSettingsDisplayType;
      lookAheadMonths: number;
      eventTags: string[];
    },
  ) => void;
};

export const StartNewOperatorWidget = ({
  setOnCloseClick,
  setCancelButtonProps,
  setNextButtonProps,
  onClose,
  onNextClick,
}: StartNewOperatorWidgetProps) => {
  const { t } = useTranslation("widgets", {
    keyPrefix: "CREATE_NEW.OPERATOR_WIDGET",
  });

  const { widgetDetails, listOptions, loading, error, setWidgetDetails } =
    useStartNewOperatorWidget({
      onClose,
      onNextClick,
      setOnCloseClick,
      setCancelButtonProps,
      setNextButtonProps,
    });

  return (
    <>
      <Flex flexDir={"column"} gap={"200"}>
        <Text visual={"bodySemiBold"}>{t("WIDGET_NAME.TITLE")}</Text>
        <Input
          onChange={(e) =>
            setWidgetDetails((prev) => ({ ...prev, name: e.target.value }))
          }
          hint={t("WIDGET_NAME.HINT")}
        />
      </Flex>
      <Flex flexDir={"column"} gap={"100"}>
        <Text visual={"bodySemiBold"}>{t("SOURCE_LIST.TITLE")}</Text>
        <Flex flexDir={"column"} gap={"200"}>
          <Text color={"text.mid"}>{t("SOURCE_LIST.DESCRIPTION")}</Text>
          {!loading ? (
            <Select.Root
              items={listOptions}
              value={[widgetDetails.listId]}
              placeholder={t("SOURCE_LIST.PLACEHOLDER")}
              onValueChange={({ value }) =>
                setWidgetDetails((prev) => ({ ...prev, listId: value[0] }))
              }
            >
              {listOptions.map((listOption) => (
                <Select.Item
                  key={listOption.value}
                  item={listOption}
                  color={
                    listOption.value === "new"
                      ? "text.accent.blue.mid"
                      : undefined
                  }
                />
              ))}
            </Select.Root>
          ) : (
            <>{error ? <SimpleErrorNotification /> : <SimpleLoader />}</>
          )}
        </Flex>
      </Flex>
    </>
  );
};
